/**
 * Created by Jie Gao on 05/24/2019.
 */

import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GGReelSymbol} from "./GGReelSymbol";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineLite, TweenLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export class GGReelSymbolL extends GGReelSymbol {
    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    public playWinAnimation():TimelineLite {
        this.createWinFrame();
        return new TimelineLite().add([
            () => {
                this._winFrame.scale.x = 1;
                this._winFrame.renderable = true;
                this._winFrame.visible = true;
                this._winFrame.state.setAnimation(0, `Size_3`, false);
            }
        ]).add(() => this.hideSymbolAnimation(), 1);
    }

    protected createSymAnimation():void {
        if(this._symbolAnimations) {
            this._symbolAnimations.destroy();
        }
        this._symbolAnimations = this.createSpineAnimation(this.symName, this.calDisplayScale(this.symHeight));
        this.addChild(this._symbolAnimations);
        this._symbolAnimations.position.set(0,0);
        this._symbolAnimations.visible = false;
        this._symbolAnimations.renderable = false;
    }

    protected calDisplayScale(symHeight:number):number {
        return Math.max(0.7, MathHelper.roundToDecimals(symHeight / 181, 2));
    }

    //for symbols: Ls
    public updateBackground(symHeight:number):void {
        super.updateBackground(symHeight);
        for(let stateName in this._stateAnimations) {
            const state = this._stateAnimations[stateName];
            if(state != null) {
                state.scale.set(this._displayScale, this._displayScale);
            }
        }
    }

    public updateAnimations(symHeight:number):void {}
}